import { useQuery } from "@tanstack/react-query";
import { getPublicAuthHeader, getReturnWidgetBaseUrl } from "./return-widget-client";

export type CatalogProductVariant = {
  id: string;
  title: string | null;
  imageUrl: string | null;
  selectedOptions: { name: string; value: string }[];
};

export type CatalogProductOption = { name: string; values: string[] };

export type CatalogProduct = {
  title: string;
  featuredImageUrl: string | null;
  options: CatalogProductOption[];
  variants: CatalogProductVariant[];
};

export function useCatalogProduct(
  shopId: string,
  productId: string | null | undefined,
) {
  return useQuery<CatalogProduct>({
    queryKey: ["catalog-product", shopId, productId],
    queryFn: async () => {
      const base = getReturnWidgetBaseUrl().replace(/\/$/, "");
      const url = new URL(`${base}/public/catalog-products/${productId}`);
      url.searchParams.set("shopId", shopId);
      const res = await fetch(url.toString(), { headers: getPublicAuthHeader() });
      if (!res.ok) throw new Error(`catalog-products ${res.status}`);
      return res.json() as Promise<CatalogProduct>;
    },
    enabled: !!shopId && !!productId,
    staleTime: 5 * 60 * 1000,
  });
}
